import config from "config/website";
import { useIntl, defineMessages } from "react-intl";

const DEFAULT_OPTIONS = [
  {
    label: "default",
    value: "",
  },
  {
    label: "asc",
    value: JSON.stringify({ field: "price", direction: "asc" }),
  },
  {
    label: "desc",
    value: JSON.stringify({ field: "price", direction: "desc" }),
  },
];

const messages = defineMessages({
  default: {
    id: "components.molecules.Sorting.default",
    defaultMessage: "Popular",
  },
  asc: {
    id: "components.molecules.Sorting.price.asc",
    defaultMessage: "Ascending price",
  },
  desc: {
    id: "components.molecules.Sorting.price.desc",
    defaultMessage: "Descending price",
  },
});

const pageLengthOptions = config["available_page_sizes"] ?? [18];

const useOptions = () => {
  const intl = useIntl();
  return {
    pageLengthOptions: pageLengthOptions.map((number) => ({
      label: number.toString(),
      value: number.toString(),
    })),
    sortOptions: DEFAULT_OPTIONS.map((option) => ({
      label: intl.formatMessage(messages[option.label]),
      value: option.value,
    })),
  };
};

export default useOptions;
